import { TagKindSchema, TagSchema } from "@redotech/redo-model/tag";
import { z } from "zod";

export const getTeamTags = {
  input: z.object({ kind: TagKindSchema }),
  output: z.object({ tags: z.array(TagSchema) }),
};
